import {APIClient} from 'cx-api-client-lite';

import {SKU_FREE_TRIAL} from '../../constants/sku';

/**
 * @typedef {function(payload: {}=): Promise<{data: {}, headers: {}, status: Number}>} ApiMethod
 */
/**
 * @typedef {Object} SubscriptionAPIClient
 *
 * @description Use the following prefix in the method naming: POST -> create; GET -> get; DELETE -> delete; PATCH, PUT -> update;
 *
 * @property {ApiMethod} getBenefits
 * @property {ApiMethod} getFreeTrialEligibility
 * @property {ApiMethod} getProduct
 * @property {ApiMethod} getAccountSubscriptions
 */
/**
 * @type {SubscriptionAPIClient | APIClient}
 */
const Subscription = new APIClient({
  getBenefits: {
    path: '/subs/v1/subscriptions/{externalAccountId}/benefits',
    method: 'GET',
  },
  getFreeTrialEligibility: {
    path: `/subs/v1/subscriptions/{externalAccountId}/eligibility/${SKU_FREE_TRIAL}`,
    options: {
      params: {
        action: 'free_trial_preliminary',
      },
    },
    method: 'GET',
  },
  getProduct: {
    path: `/subs/v2/products/{sku}`,
    method: 'GET',
  },
  getAccountSubscriptions: {
    path: '/subs/v3/subscriptions/{externalAccountId}',
    method: 'GET',
  },
});

export default Subscription;
